export default "__VITE_ASSET__CyjGgDtB__"